import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import PushService from 'services/PushService';

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: localStorage.getItem(AUTH_TOKEN) || null,
	loadingClearAll: false,
	todasNotificacoes: [],
	todasNotificacoesPagination: {
		totalElements: 0,
		totalPages: 0,
		currentPage: 0,
		pageSize: 10,
	},
	pagination: {
		content: [],
		totalElements: 0,
		totalPages: 0,
		currentPage: 0,
		pageSize: 10,
	},
}

export const getAllPaginated = createAsyncThunk('push/allPaginated', async (params, { rejectWithValue }) => {
	try {
		const response = await PushService.paginated(params)
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao buscar notificações')
	}
})

export const getAll = createAsyncThunk('push/all', async () => {
	const response = await PushService.all()
	return response;
})

export const save = createAsyncThunk('push/save', async (data, { rejectWithValue }) => {
	try {
		const response = await PushService.save(data)
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao salvar push')
	}
})

export const getTodasNotificacoes = createAsyncThunk('push/todas', async (params, { rejectWithValue }) => {
	try {
		const response = await PushService.getTodasNotificacoes(params)
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao buscar notificações')
	}
}
)

export const getNotificacoesNovas = createAsyncThunk('push/novas', async (_, { rejectWithValue }) => {
	try {
		const response = await PushService.getNovas()
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao buscar notificações')
	}
}
)

export const getNotificacaoFull = createAsyncThunk('push/full', async (id, { rejectWithValue }) => {
	try {
		const response = await PushService.getFull(id)
		return { id, conteudo: response.conteudo };
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao buscar conteúdo')
	}
}
)

export const confirmarNotificacao = createAsyncThunk('push/confirmar', async (id, { rejectWithValue }) => {
	try {
		const response = await PushService.confirmar(id)
		return { id };
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao confirmar notificação')
	}
}
)

export const confirmarTodasNotificacoes = createAsyncThunk('push/confirmarTodas', async (_, { rejectWithValue }) => {
	try {
		const response = await PushService.confirmarTodas()
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao confirmar todas as notificações')
	}
}
)

export const pushSlice = createSlice({
	name: 'push',
	initialState,
	reducers: {
		clearPushEdicao: (state) => {
			state.edicao = null;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getAllPaginated.pending, (state) => {
				state.loading = true
			})
			.addCase(getAllPaginated.fulfilled, (state, action) => {
				state.loading = false
				state.pagination = {
					content: action.payload.content,
					totalElements: action.payload.totalElements,
					totalPages: action.payload.totalPages,
					currentPage: action.payload.number,
					pageSize: action.payload.size,
				}
			})
			.addCase(getAllPaginated.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(getAll.pending, (state) => {
				state.loading = true
			})
			.addCase(getAll.fulfilled, (state, action) => {
				state.loading = false
				// state.redirect = '/'
				state.pushs = action.payload
			})
			.addCase(getAll.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(save.pending, (state) => {
				state.loading = true
			})
			.addCase(save.fulfilled, (state, action) => {
				state.loading = false
				// state.redirect = '/app/cliente/default'
				// state.users = action.payload
				state.edicao = null
			})
			.addCase(save.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(getNotificacoesNovas.pending, (state) => {
				state.loading = true
			})
			.addCase(getNotificacoesNovas.fulfilled, (state, action) => {
				state.loading = false
				state.notificacoes = action.payload || []
				state.count = action.payload?.length || 0
			})
			.addCase(getNotificacoesNovas.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
				state.notificacoes = []
				state.count = 0
			})
			.addCase(getNotificacaoFull.pending, (state, action) => {
			})
			.addCase(getNotificacaoFull.fulfilled, (state, action) => {
				const { id, conteudo } = action.payload
				const notificacao = state.notificacoes.find(n => n.id === id)
				if (notificacao) {
					notificacao.conteudo = conteudo
				}
			})
			.addCase(getNotificacaoFull.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
			})
			.addCase(confirmarNotificacao.pending, (state, action) => {
				// Opcional: adicionar loading para a notificação específica
			})
			.addCase(confirmarNotificacao.fulfilled, (state, action) => {
				const { id } = action.payload
				// Remove a notificação da lista
				state.notificacoes = state.notificacoes.filter(n => n.id !== id)
				state.count = state.notificacoes.length
			})
			.addCase(confirmarNotificacao.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
			})
			.addCase(confirmarTodasNotificacoes.pending, (state) => {
				state.loadingClearAll = true
			})
			.addCase(confirmarTodasNotificacoes.fulfilled, (state, action) => {
				state.loadingClearAll = false
				// Limpa todas as notificações
				state.notificacoes = []
				state.count = 0
			})
			.addCase(confirmarTodasNotificacoes.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loadingClearAll = false
			})
			.addCase(getTodasNotificacoes.pending, (state) => {
				state.loading = true
			})
			.addCase(getTodasNotificacoes.fulfilled, (state, action) => {
				state.loading = false
				const payload = action.payload || {}
				state.todasNotificacoes = payload.content || []
				state.todasNotificacoesPagination = {
					totalElements: payload.totalElements || 0,
					totalPages: payload.totalPages || 0,
					currentPage: payload.number || 0,
					pageSize: payload.size || 10,
				}
			})
			.addCase(getTodasNotificacoes.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
				state.todasNotificacoes = []
				state.todasNotificacoesPagination = {
					totalElements: 0,
					totalPages: 0,
					currentPage: 0,
					pageSize: 10,
				}
			})
	},
})

export const {
	showLoading,
	clearPushEdicao
} = pushSlice.actions

export default pushSlice.reducer